const getCommercialCategories = (serverCommercialCategories) => {
  return serverCommercialCategories.map((category) => ({
    key: category.key ?? void 0,
    name: category.name ?? void 0,
    ancestors: category.ancestors.map((ancestor) => ({
      key: ancestor.key ?? void 0,
      name: ancestor.name ?? void 0
    }))
  }));
};
export {
  getCommercialCategories
};
//# sourceMappingURL=get-commercial-categories.js.map
